// =============================================================================
// FILE: packages/renderer/src/components/auth/LicenseLock.tsx
// PURPOSE: "Non-Transferable License" lock screen shown when a Legacy Perpetual
//   license is opened on a machine that does not match its bound HWID. Provides
//   the transfer path and the master-admin reset hint.
// =============================================================================

import { type JSX } from 'react';
import { Lock, Mail, RefreshCw } from 'lucide-react';

export function LicenseLock({ message }: { message: string }): JSX.Element {
  return (
    <div data-testid="license-lock" className="fixed inset-0 z-[10001] grid place-items-center p-6"
      style={{ background: 'rgba(4,7,14,0.96)', backdropFilter: 'blur(10px)' }}>
      <div className="w-full max-w-lg rounded-2xl overflow-hidden text-center"
        style={{ background: 'rgba(9,13,22,0.98)', border: '1px solid rgba(248,113,113,0.4)', boxShadow: '0 30px 120px rgba(0,0,0,0.8)' }}>
        <div className="px-8 py-8">
          <div className="mx-auto grid place-items-center rounded-full mb-4" style={{ width: 56, height: 56, background: 'rgba(248,113,113,0.12)', border: '1px solid rgba(248,113,113,0.4)' }}>
            <Lock className="h-6 w-6 text-rose-300" />
          </div>
          <div className="text-[10px] uppercase tracking-[0.28em] text-rose-300/80 mb-1">RCD² Legacy License</div>
          <h2 className="text-xl font-bold text-zinc-100">Non-Transferable License</h2>
          <p className="text-[13px] text-zinc-400 leading-relaxed mt-3">
            {message || 'This license is locked to another device. Please purchase a separate license or contact us to transfer your seat (transfer fee may apply).'}
          </p>
          <a data-testid="license-transfer-link" href="mailto:rcd2engine@gmail.com?subject=RCD2%20Legacy%20License%20-%20Seat%20Transfer"
            className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 rounded-lg text-[12px] font-bold text-zinc-900 transition hover:brightness-95" style={{ background: '#fca5a5' }}>
            <Mail className="h-4 w-4" /> Request a Seat Transfer
          </a>
          <div className="flex items-center justify-center gap-2 text-[11px] text-zinc-600 mt-4">
            <RefreshCw className="h-3 w-3" /> A Master Admin can reset this license's device binding.
          </div>
        </div>
      </div>
    </div>
  );
}
